import * as React from 'react';

import {LoadingPage} from 'shells/loading-page/loading-page';

import type {GetAccountsForLead_lead_accounts_edges as AccountEdge} from 'nutshell-graphql-types';

import type {Option} from '../../../../core/select/graphql-select-creatable';
import {ContactRow} from '../../../../core-entity/rows/peep-rows/contact-row';

import {LeadCompanyRow} from './lead-company-row';

import styles from './peeps-row.module.css';

type Props = {
    leadId: string;
    account: AccountEdge;
    isCreatingContact: boolean;
    contactParentAccount: Option | null | undefined;
    isRefetching: boolean;
    phoneCallerType: string | null | undefined;
    userCanUseSms: boolean | null | undefined;
    sendFromNutshellEnabled: boolean | null | undefined;
    CreateContactForm: React.ReactNode;
    setIsCreatingContact: (arg1: boolean) => void;
    setContactParentAccount: (arg1: Option) => void;
    handleRemoveAccount: (arg1: string) => void;
    handleOpenEmailModal: (arg1: string) => void;
    handleRemoveContact: (contactId: string, contactParentAccountId?: string) => void;
    setError: (arg1: string) => void;
    hasConnectedPhoneIntegration: boolean;
};

export function PeepsRow(props: Props) {
    const {account} = props;

    const accountCardRowRef = React.useRef<HTMLDivElement | null | undefined>(null);
    const [accountCardHeight, setAccountCardHeight] = React.useState<number>(24);

    React.useEffect(() => {
        if (accountCardRowRef.current) {
            const height = accountCardRowRef.current.offsetHeight;
            if (height > 0) {
                setAccountCardHeight(height);
            }
        }
    }, [account]);

    return (
        <React.Fragment key={account.node.id}>
            {/* @ts-expect-error */}
            <div ref={accountCardRowRef}>
                <LeadCompanyRow
                    leadId={props.leadId}
                    accountId={account.node.id}
                    name={account.node.name}
                    avatarUrl={account.node.avatarUrl}
                    accountUrl={account.node.htmlUrlPath}
                    description={account.node.description}
                    location={
                        account.node.postalAddresses.primary &&
                        account.node.postalAddresses.primary.location.formattedAddress
                    }
                    parentEntityName='Leads'
                    isDuplicate={account.node.hasDuplicates}
                    setIsCreatingContact={props.setIsCreatingContact}
                    setContactParentAccount={props.setContactParentAccount}
                    removeAccount={props.handleRemoveAccount}
                    setError={props.setError}
                    phone={account.node.phones.primary && account.node.phones.primary.value}
                    phoneCallerType={props.phoneCallerType}
                    hasConnectedPhoneIntegration={props.hasConnectedPhoneIntegration}
                />
            </div>
            {props.isCreatingContact &&
                props.contactParentAccount &&
                props.contactParentAccount.id === account.node.id &&
                props.CreateContactForm}
            {props.isRefetching &&
                props.contactParentAccount &&
                props.contactParentAccount.id === account.node.id && <LoadingPage padding={8} />}
            {account.leadAccountContacts && account.leadAccountContacts.length > 0 ? (
                <div className={styles.container}>
                    <div
                        style={{
                            marginTop: `${45 - accountCardHeight}px`,
                        }}
                        className={styles['grouping-line-container']}
                    >
                        <div className={styles['left-grouping-line']} />
                    </div>
                    <div className={styles.content}>
                        {account.leadAccountContacts.map((contact) => (
                            <div key={contact.id} className='pl-12'>
                                <ContactRow
                                    contactId={contact.id}
                                    name={contact.name}
                                    contactUrl={contact.htmlUrlPath}
                                    description={contact.description}
                                    role={contact.jobTitle}
                                    phone={contact.phones.primary && contact.phones.primary.value}
                                    phoneCallerType={props.phoneCallerType}
                                    userCanUseSms={props.userCanUseSms}
                                    email={contact.primaryEmailAddress}
                                    lastContactedTime={contact.lastContactedTime}
                                    isDuplicate={contact.hasDuplicates}
                                    avatarUrl={contact.avatarUrl}
                                    parentEntityName='Leads'
                                    onOpenEmailModal={props.handleOpenEmailModal}
                                    removeContact={props.handleRemoveContact}
                                    contactParentAccount={account.node.id}
                                    setError={props.setError}
                                    hasConnectedPhoneIntegration={
                                        props.hasConnectedPhoneIntegration
                                    }
                                    sendFromNutshellEnabled={props.sendFromNutshellEnabled}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            ) : null}
        </React.Fragment>
    );
}
